import { ChatResponseOption } from '@akin-home/chat';
import { isAndroidBuild } from '@akin-home/utils/native';
import { useRef } from 'react';
import { FlatList, StyleSheet } from 'react-native';
import { ChatItem, ChatItemTypes } from '../../../ChatItem/types';
import { ChatItemComponents as ChatComponents } from '../ChatItems';

type Props = {
  items: ChatItem[];

  onPressOption?(option: ChatResponseOption, index: number): void;
};

export function ChatItemsView(props: Props) {
  const { items } = props;

  const flat_list_ref = useRef<FlatList>(null);

  function scrollToLastItem() {
    if (items.length > 0) {
      if (isAndroidBuild()) {
        flat_list_ref.current?.scrollToIndex({
          index: items.length - 1,
          animated: true,
        });
      } else {
        scrollToBottom();
      }
    }
  }

  function scrollToBottom() {
    flat_list_ref.current?.scrollToEnd({ animated: true });
  }

  return (
    <FlatList
      ref={flat_list_ref}
      onContentSizeChange={scrollToLastItem}
      onScrollToIndexFailed={scrollToBottom}
      data={items}
      contentContainerStyle={styles.flat_list_container}
      renderItem={({ item, index }) => (
        <ChatItemView
          item={item}
          index={index}
          onPressOption={props.onPressOption}
        />
      )}
    />
  );
}

type ChatItemProps = {
  item: ChatItem;
  index: number;

  onPressOption?(
    option: ChatResponseOption,
    index: number,
    context?: any
  ): void;
  onPressDoneMultiselect?(message: string, index: number): void;
  onPressSkipMultiselect?(message: string, index: number): void;
};

export function ChatItemView(props: ChatItemProps) {
  const { item, index } = props;

  switch (item.type) {
    case ChatItemTypes.USER:
      return <ChatComponents.UserTextItem item={item} />;
    case ChatItemTypes.TEXT: {
      if (item.commands?.some((cmd) => cmd.type === 'display_emotion_picker')) {
        return (
          <ChatComponents.EmotionPicker
            item={item}
            index={index}
            onPressOption={props.onPressOption}
          />
        );
      } else if (
        item.commands?.some((cmd) => cmd.type === 'display_scale_options')
      ) {
        return (
          <ChatComponents.EmotionScalePicker
            item={item}
            index={index}
            onPressOption={props.onPressOption}
          />
        );
      }

      return (
        <ChatComponents.TextItem
          item={item}
          index={index}
          onPressOption={props.onPressOption}
        />
      );
    }

    default:
      return null;
  }
}

const styles = StyleSheet.create({
  flat_list_container: {
    gap: 12,
    paddingTop: 12,
    paddingBottom: 12,
  },
});
